import script from "./left_fs.vue?vue&type=script&setup=true&lang=js"
export * from "./left_fs.vue?vue&type=script&setup=true&lang=js"

import "./left_fs.vue?vue&type=style&index=0&id=33838da8&scoped=true&lang=css"
script.__scopeId = "data-v-33838da8"

export default script